import { OpaqueString } from "../Opaque"

/** A type that allows the user to expand an enum with a custom specified value */
export type OtherString = OpaqueString<"Other">
